var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{class:[_vm.enableClick ? 'cursor-pointer' : 'cursor-default'],on:{"click":_vm.onClick}},[_vm._t("default",null,{"active":_vm.active})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }